import {BaseApi} from '@/api/base-api';
import {getApiUrl, getTokenFromCookies} from '@/api/common-utils';
import {Button} from '@/components/common-components/v2/Button';

import {CurrentPageStore} from '@/store/content-optimizer/currentPage';
import {faDownLeftAndUpRightToCenter, faFileDownload, faUpRightAndDownLeftFromCenter} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Tooltip} from 'antd';
import {useState} from 'react';
import styled from 'styled-components';
import {observer} from 'mobx-react';
import {faCheck, faSyncAlt} from '@fortawesome/pro-regular-svg-icons';
import {isScaPublicPage} from '@/utils/url';

interface Props {
  currentView?: 'links' | 'terms';
  store: CurrentPageStore;
}


export const LinkSuggestionsDropdownController = observer(({currentView, store}: Props) => {
  const [isSynced, setIsSynced] = useState(false);
  const [isSyncing, setIsSyncing] = useState(false);
  const isNotPublic = !isScaPublicPage();

  const onLinksSync = async () => {
    try {
      setIsSyncing(true);
      // await store?.getInternalLinkSuggestions(store?.content?.uuid, true);
      await store?.getInternalLinkSuggestionsv2(store?.content?.uuid, true);
      setIsSynced(true);
      setTimeout(() => {
        setIsSynced(false);
      }, 3000);
    } catch (e) {
      setIsSyncing(false);
    } finally {
      setIsSyncing(false);
    }
  };

  const getXlsExportLink = () => {
    const token = getTokenFromCookies();
    if (store?.content?.uuid) {
      const baseUrl = getApiUrl(BaseApi.CA_ENDPOINT, `/api/pages/${store?.content?.uuid}/export-data-to-xls/`);
      const savedKeywordsUrl=`${baseUrl}?&jwt=${token}`;
      return savedKeywordsUrl;
    }
  };


  return <Container current={currentView}>
    <Tooltip title='Expand this section'>
      <FocusModeBtn variant='ghost' color='textGrayLight' onClick={() => store.setFocusTermsExpanded(!store.focusTermsExpanded)}>
        <FontAwesomeIcon icon={store?.focusTermsExpanded ? faDownLeftAndUpRightToCenter : faUpRightAndDownLeftFromCenter} color='#E8E8E8' style={{fontSize: 12, marginRight: 5}}/>
        <FocusModeLabel>{store?.focusTermsExpanded ? 'Default Mode' : 'Focus Mode'}</FocusModeLabel>
      </FocusModeBtn>
    </Tooltip>

    {/* <Dropdown overlay={viewChangeDropdown} placement='bottomCenter' trigger={['click']}>
      <ButtonStyled>{currentView === 'links' ? 'Internal' : 'External links'}<FontAwesomeIcon icon={faCaretDown} style={{marginLeft: 5}}/></ButtonStyled>
    </Dropdown>

    {currentView === 'links' ? <Dropdown trigger={['click']} overlay={keywordsDropdown} placement='bottomCenter'>
      <ButtonStyled>Keywords <FontAwesomeIcon icon={faCaretDown} style={{marginLeft: 5}}/></ButtonStyled>
    </Dropdown> : null} */}

    {isNotPublic && (currentView === 'links' ? <Tooltip title='Export to XLS'>
      <ExportIcon href={getXlsExportLink()}><FontAwesomeIcon icon={faFileDownload} color='#E8E8E8' style={{fontSize: 14, marginRight: 5}}/> Export</ExportIcon>
    </Tooltip> : null)}


    <Tooltip
      visible={isSynced}
      placement='topRight'
      arrowPointAtCenter={true}
      overlayInnerStyle={{borderRadius: 5, backgroundColor: '#000'}}
      title={<><FontAwesomeIcon icon={faCheck} style={{color: '#1fac47'}}/> Suggestions Updated</>}>
      <RefetrchBtnContainer style={{cursor: 'pointer'}} onClick={() => onLinksSync()}>
        <FontAwesomeIcon icon={faSyncAlt} spin={isSyncing} style={{fontSize: 14, marginRight: 5}} />
        Refetch
      </RefetrchBtnContainer>
    </Tooltip>

  </Container>;
});

const Container = styled.div<{current: string}>`
  display: flex;
  align-items: center;
  padding: 10px 15px;
  justify-content: ${p => p.current === 'links' ? 'space-between' : 'flex-start'};
`;


const FocusModeBtn = styled(Button)`
  background: transparent;
  padding: 4px 0px;
  font-size: 12px !important;
  height: 28px !important;
  margin-left: 0px;

  &:focus,
  &:hover {
    background: transparent;
  }
`;

const FocusModeLabel = styled.span`
  color: #E8E8E8;
  font-size: 12px;
  margin-bottom: -2px;
`;

const ExportIcon = styled.a`
  display: flex;
  align-items: center;
  cursor: pointer;
  background: transparent;
  font-size: 12px !important; 
  margin-left: auto;
  margin-right: 0px;
  color: #fff;
  padding: 7px 20px;
  height: 28px !important;

  &:focus,
  &:hover {
    background: transparent;
    color: #fff;
  }
`;


const RefetrchBtnContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-right: 0px;
`;
